<template>
    <div class="page">
        <div class="page-bd">
            <div class="edit-box">
                <div class="f-bd f14 text-nowrap">{{$t('op_date')}}{{$t('x_mh')}}</div>
                <div class="mg-right10"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right10" v-if="org_level == '0'">
                    <Input v-model="search.org_code" :placeholder="$t('code_name')">
                        <span slot="prepend">{{$t('org')}}{{$t('x_yd')}}</span>
                    </Input>
                </div>
                <div class="mg-right10" v-else>
                    <myOrgSelfAndDown :orgs="orgs" @onChange="onOrgChange"></myOrgSelfAndDown>
                </div>
                <div class="mg-right10">
                    <Input v-model="search.func_cdesc">
                        <span slot="prepend">{{$t('func_cdesc')}}{{$t('x_yd')}}</span>
                    </Input>
                </div>
                <div class="mg-right10"><Button type="primary" @click="list(false)">{{$t('list')}}</Button></div>
                <div class="mg-right10"><Button type="success" @click="exportExcel">{{$t('export')}}</Button></div>
            </div>
            <div class="table-box">
                <div class="table-box-header mini-scrollbar" ref="table_box_header" style="overflow-y: scroll">
                    <Row class="table-tr th" type="flex">
                        <Col class="table-td" style="width:15%">{{listHeader.add_time}}</Col>
                        <Col class="table-td" style="width:10%">{{listHeader.org_code}}</Col>
                        <Col class="table-td" style="width:15%">{{listHeader.org_cname}}</Col>
                        <Col class="table-td" style="width:15%">{{listHeader.role_cname}}</Col>
                        <Col class="table-td" style="width:15%">{{listHeader.func_cdesc}}</Col>
                        <Col class="table-td" style="width:10%">{{listHeader.add_user_code}}</Col>
                        <Col class="table-td" style="width:10%">{{listHeader.add_user_cname}}</Col>
                        <Col class="table-td" style="width:10%">{{listHeader.add_ip}}</Col>
                    </Row>
                </div>
                <div class="table-box-content mini-scrollbar" ref="table_box_content" style="overflow-x: hidden" :style="table_box_content_style" @scroll="$base.setTableBoxContentScroll(self,false)">
                    <myNodata v-show="totalData.total <= 0" :last_time="search.search_time"></myNodata>
                    <Row class="table-tr even-line-bcolor" type="flex" align="middle" v-for="(item,index) in listData" :key="index">
                        <Col class="table-td" style="width:15%">{{item.add_time}}</Col>
                        <Col class="table-td" style="width:10%">{{item.org_code}}</Col>
                        <Col class="table-td" style="width:15%">{{item.org_cname}}</Col>
                        <Col class="table-td" style="width:15%">{{item.role_cname}}</Col>
                        <Col class="table-td" style="width:15%">{{item.func_cdesc}}</Col>
                        <Col class="table-td" style="width:10%">{{item.add_user_code}}</Col>
                        <Col class="table-td" style="width:10%">{{item.add_user_cname}}</Col>
                        <Col class="table-td" style="width:10%">{{item.add_ip}}</Col>
                    </Row>
                </div>
                <div class="table-pager" v-show="totalData.total > 0">
                    <myPager :limit="search.limit" @onLimitChange="onLimitChange"
                             v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
                </div>
            </div>
        </div>
        <!-- <download-excel :data="excelData" :fields="exportHeader" :name="export_title" v-show="false">
            <a type="success" ref="btn_excel"></a>
        </download-excel> -->
    </div>
</template>

<script>
    import myPager from '../../components/myPager'
    import myNodata from '../../components/myNodata'
    import myDropdown from '../../components/myDropdown'
    import myDatePicker from '../../components/myDatePicker'
    import myOrgSelfAndDown from '../../components/myOrgSelfAndDown'
    export default {
        name:"system-mod",
        components:{
            myPager,
            myNodata,
            myDropdown,
            myDatePicker,
            myOrgSelfAndDown
        },
        data:function(){
            const listHeader = {
                add_time: this.$t('op_date'),
                add_user_code: this.$t('add_user_code'),
                add_user_cname: this.$t('add_user_cname'),
                org_code: this.$t('org_code'),
                org_cname: this.$t('org_name'),
                role_cname: this.$t('use_role_cname'),
                func_cdesc: this.$t('func_cdesc'),
                add_ip: 'IP',
            };
            return{
                title: this.$t('gsreport_cp_dtl'),
                export_title: '',
                org_level:this.$base.getOrgLevel(),
                table_box_content_style: {
                    height:"200px"
                },
                table_box_content_fixed_style: {
                    height:"200px"
                },
                search:{
                    search_url: "system/ops-list",
                    search_time: new Date(),//最新查询时间
                    datearea_id:1,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: '',
                    org_code: '',
                    org_id: '',
                    func_cdesc: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0
                },
                listHeader,//表结构
                listData: [],
                excelData: [],
                exportHeader : this.$base.changeJsonKeyValue(listHeader),
                totalData: {
                    total: 0,//总行数
                },
                orgs: [
                    {
                        value:'',
                        label:this.$t('org_self')
                    }
                ]
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();

            var datearea = this.$base.getDateArea(this.search.datearea_id);
            this.search.date_fr = datearea.date_fr;
            this.search.date_to = datearea.date_to;

            var table_box_height = this.$base.getTableBoxHeight(this.$refs['table_box_content']);
            this.table_box_content_style.height = table_box_height + 'px';
            table_box_height -= 10;
            this.table_box_content_fixed_style.height = table_box_height + 'px';

            this.getLoad();
        },
        methods:{
            onOrgChange:function(data){
                this.search.org_id = data.org_id;
                this.list();
            },
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            getLoad: function () {
                let data = {};
                this.$base.showLoading();
                this.$request.sendPost('system/before-ops-list', data, (success, data, error) => {
                    this.$base.hideLoading();
                    if(success){
                        if(this.org_level == '1'){
                            data.orgs.forEach((item)=>{
                                item.children = this.orgs.concat(item.children);
                            });
                        }
                        this.orgs = this.orgs.concat(data.orgs);
                        this.list();
                    }
                    else {
                        this.$base.alertErr(error.errmsg);
                    }
                })
            },
            list: function (change_page) {
                if(!change_page) this.search.page = 1;
                this.search.search_time = new Date();
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data.list;
                        this.search.pageSize = parseInt(data.last_page);
                        this.totalData.total = data.total.total;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            exportExcel: function(){
                this.$base.exportExcel(this);
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/system/ops.vue